<template>
  <div class="balance py-6 px-8">
    <h-header>
      <template v-slot:actions>
        <IntegrationCreate />
      </template>
    </h-header>

    <v-card outlined>
      <v-data-table
        disable-sort
        hide-default-footer
        mobile-breakpoint="20"
        :headers="headers"
        :items="integrations"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        :no-data-text="$t('appointment.table.noData')"
        :loading-text="$t('appointment.table.loading')"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="openEditModal(item.id)" class="mx-2" icon small>
            <v-icon small> mdi-pencil </v-icon>
          </v-btn>
          <v-btn
            @click="openDeleteModal(item.id, item.external_source)"
            class="mx-2"
            icon
            small
          >
            <v-icon small> mdi-delete </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <IntegrationUpdate ref="integrationUpdate" />
    <DeleteModal
      :callback="fetchIntegrations"
      toDelete="deleteIntegration"
      ref="deleteIntegrationModal"
    />
    <h-pagination :fetch="fetchIntegrations" :requireOrderByFilter="false" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import IntegrationUpdate from '@/components/integration/IntegrationUpdate'
import IntegrationCreate from '@/components/integration/IntegrationCreate'
import DeleteModal from '@/components/app/DeleteModal'

export default {
  name: 'IntegrationList',

  components: { DeleteModal, IntegrationUpdate, IntegrationCreate },

  data() {
    return {
      headers: [
        {
          text: this.$t('integration.label.externalSource'),
          value: 'external_source',
          width: '200',
        },
        {
          text: this.$t('integration.label.apiUrl'),
          value: 'api_url',
          width: '400',
        },
        {
          text: this.$t('integration.label.keyCode'),
          value: 'key_code',
          width: '300',
        },
        { value: 'actions', align: 'end', width: '150' },
      ],
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'itemsPerPage', 'integrations']),
  },

  mounted() {
    this.fetchIntegrations()
  },

  methods: {
    ...mapActions(['fetchIntegrations']),

    openEditModal(integrationId) {
      this.$refs.integrationUpdate.openModal(integrationId)
    },

    openDeleteModal(integrationId, integrationKey) {
      this.$refs.deleteIntegrationModal.openModal(integrationId, integrationKey)
    },
  },
}
</script>
